// Wrap a reducer in a higher-order reducer that is associated with a specific
// context name. That context name is passed to the actions that should affect
// the inner reducer instance.
// http://redux.js.org/docs/recipes/reducers/ReusingReducerLogic.html
export default function(reducerFunction, reducerContext) {
  return function(state, action) {
    const {context} = action;
    const isInitializationCall = (state === undefined);

    if(context !== reducerContext && !isInitializationCall) {
      return state;
    }

    return reducerFunction(state, action);
  };
}



// WEBPACK FOOTER //
// ./src/store/instancedReducer.js